import React, { Component } from 'react'
import { Field } from 'redux-form';
import LocationField from './LocationField'

const required = (message = 'Please select from suggestion') =>
  value => {
    return (value && value.coordinates) ? undefined : message;
  }

class LocationInput extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { source, label } = this.props
    // console.log(this.props)
    return (
      <Field style={{ width: "100%" }} name={source} label={label} component={LocationField} />
    )
  }
}

export default LocationInput